// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"d6e78f41","977":"bece3139"}[chunkId] + ".chunk.js";
};